import { Component, Input } from '@angular/core';
import { BaseReportWithPatientData } from '../../models/compact-report-with-patient-data.model';
import { InlineReadonlyFieldComponent } from '@shared/modules/readonly-commons/components/inline-readonly-field/inline-readonly-field.component';
import { ValueSeparatorComponent } from '@shared/modules/general-commons/components/value-separator/value-separator.component';
import { PatientLinkComponent } from '../patient-link/patient-link.component';

@Component({
  selector: 'stx-compact-patient-data',
  templateUrl: './compact-patient-data.component.html',
  imports: [InlineReadonlyFieldComponent, ValueSeparatorComponent, PatientLinkComponent]
})
export class CompactPatientDataComponent {
  @Input() recordData: BaseReportWithPatientData;
}
